import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addRelationShipData,
  deleteShiftingMatrixData,
  fetchShiftingMatrixData,
  updateShiftingMatrixData,
} from "../../apis/shifting";


export const fetchShiftingMatrix = createAsyncThunk(
  "shifting/fetchShiftingMatrix",
  async ({
    sort
  }:{
    sort?: {
      field: string;
      direction: string | null | undefined
    };
  }, { rejectWithValue }) => {
    try {
      const shiftingMatrix = await fetchShiftingMatrixData(sort);
      return shiftingMatrix;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },{
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.shifting.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updateShiftingMatrix = createAsyncThunk(
  "shifting/updateShiftingMatrix",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        shiftingMatrixId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateShiftingMatrixData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteShiftingMatrix = createAsyncThunk(
  "shifting/deleteShiftingMatrix",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteShiftingMatrixData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewRelationship = createAsyncThunk(
  "shifting/addNewRelationship",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addRelationShipData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
